// FYI
// packages/@guardian/src-foundations/src/utils/px-to-rem.ts SYMLINKS TO
// packages/@guardian/source-foundations/src/utils/px-to-rem.ts
export const rootPixelFontSize = 16;
export const pxToRem = (px) => px / rootPixelFontSize;
//# sourceMappingURL=px-to-rem.js.map
